import React from 'react';
import { Radio } from 'antd';
import useContainerRef from '@src/hooks/utils/useContainerRef';
import { StyledResizeLabel } from './styled';
import { heightAtom } from '../atoms';
import { useAtom } from 'jotai';

export const BASE_HEIGHT = 3;
export const TABLE_HEIGHT_MAPPING = {
  s: BASE_HEIGHT + 7, // row span of 10, each row is 47px => dropdown + header + total + 7 data rows
  m: BASE_HEIGHT + 12, // ~ 12 data rows
  l: BASE_HEIGHT + 17, // ~ 17 data rows
};

const options = [
  { label: 'Short', value: 's' },
  { label: 'Medium', value: 'm' },
  { label: 'Long', value: 'l' },
];

function Resize() {
  const [height, setHeight] = useAtom(heightAtom);
  const handleHeightChange = (e) => {
    const value = e.target.value;
    setHeight(value);
  };

  const { containerRef, getContainer } = useContainerRef();

  return (
    <div ref={containerRef}>
      <StyledResizeLabel>Dimension Height</StyledResizeLabel>
      <Radio.Group
        options={options}
        onChange={handleHeightChange}
        value={height}
        optionType="button"
        size="small"
      />
    </div>
  );
}

export default Resize;
